import axios from "axios";
import { API } from "../../../backend";
import authHeader from "../../auth-header"

const addPaymentSchedule = (id,no_of_payments, payment_type, amount,frequency, start_date,end_date,payment_schedule) => {
  return axios.post(API + "contracts/payment-add/"+id+"/", {
    no_of_payments,
    payment_type,
    amount,
    frequency,
    start_date,
    end_date,
    payment_schedule
  },{headers: authHeader(),});
};

const UpdatePaymentSchedule = (id,no_of_payments, payment_type, amount,frequency, start_date,end_date,payment_schedule) => {
  return axios.post(API + "contracts/paymentschedule-update/"+id+"/", {
    no_of_payments,
    payment_type,
    amount,
    frequency,
    start_date,
    end_date,
    payment_schedule
  },{headers: authHeader(),});
};
const AddPaymentScheduleService = {
    addPaymentSchedule,
    UpdatePaymentSchedule
};
export default AddPaymentScheduleService;